import Vue from 'vue';
import LoginComponent from './login.vue';
import tips from "../tips/main";
import api from '../../api/'
import store from '@/store';

let LoginConstructor = Vue.extend(LoginComponent);
let instance;
let Login = function (options, callback) {
  options = options || {};
  if (typeof options === 'string') {
    options = {
      title: options
    };
  }
  options.store = store;
  Vue.prototype.$api = api;
  Vue.prototype.$tips = tips;
  instance = new LoginConstructor({
    data: options,
    methods: {
      onSuccess: callback
    }
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 10000;
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/login.js